import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
} from '@angular/common/http';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
// import { environment } from '../../environments/environment.local';

export const authIdInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const oidcSecurityService = inject(OidcSecurityService);
  const apiUrl = environment.api; // URL твоего API-сервера

  // Добавляем токен только для запросов к твоему API
  if (!req.url.startsWith(apiUrl)) {
    return next(req);
  }

  return oidcSecurityService.getIdToken().pipe(
    switchMap((idToken: string | null) => {
      if (idToken) {
        req = req.clone({
          headers: req.headers.set('Authorization', `Bearer ${idToken}`),
        });
      }
      return next(req);
    })
  );
};
